/** In-memory filter passed from dashboard cards (not shown in the URL). */
const pendingFilters = {};

export function queuePageFilter(path, filter) {
  if (path && filter) pendingFilters[path] = filter;
}

export function peekPageFilter(path) {
  return pendingFilters[path] ?? null;
}

export function takePageFilter(path) {
  const filter = pendingFilters[path];
  if (filter !== undefined) delete pendingFilters[path];
  return filter ?? null;
}
